export default __webpack_public_path__ + "static/pic11-975926babaae0679fe6c02b3e11dc383.jpg";